var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Button from '@cdo/apps/templates/Button';
var ModalButton = function (props) {
    var currentMode = props.currentMode, showFor = props.showFor, hideFor = props.hideFor, enableFor = props.enableFor, disableFor = props.disableFor;
    if ((showFor && !showFor.includes(currentMode)) ||
        (hideFor && hideFor.includes(currentMode))) {
        return null;
    }
    return (React.createElement(Button, __assign({ disabled: (enableFor && !enableFor.includes(currentMode)) ||
            (disableFor && disableFor.includes(currentMode)) }, props)));
};
export default ModalButton;
